import React from 'react';
import { GetStaticProps } from 'next';
import { withTheme } from '@emotion/react';
import { getStaticPropsResorts } from '@layout/get-page-props';
import { ResortsPageLayout, ResortsPageLayoutProps } from '@layout/ResortsPageLayout/ResortsPageLayout';
import { withGlobalProvider } from 'providers/globalProvider';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';
import { ERROR_CODES } from '@model/common/error-codes';
import { storeWrapper } from '@state/store';
import { getResortsStaticPaths } from '@util/get-destination-static-paths';
import { Error500 } from '@components/common/hero/error/Error500';
import { getSearchableRegions } from '@util/geography';

const ResortsRegionPage = (props: ResortsPageLayoutProps) => {
  const { cmsConfig } = props;

  if (!cmsConfig) return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;

  return <ResortsPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ params }: any) => ({
  ...(await getStaticPropsResorts({ store, params })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const continents = await new ContentApi().getGeography();
  const destinations = getSearchableRegions(continents);

  const paths = getResortsStaticPaths(destinations);

  return { paths, fallback: false };
}

export default withGlobalProvider(withTheme(ResortsRegionPage));
